<template>
  <div class="page">
    <img :src="'https://j.weizan.cn/youxiang/spokeman-poster-head.png?v=2'" class="head-img" />
    <div class="page-body disFlex vertical fc">
      <img :src="'https://j.weizan.cn/youxiang/spokeman-light-bg.png?v=2'" class="poster-bg-img" />

      <div class="box">
        <img id="canvas-pic" :src="img" v-if="canvasFlag" />

        <div id="capture" ref="poster" v-if="posterFlag">
          <img :src="poster" id="posterDOM" class="poster-img" crossorigin="anonymous" />
          <div class="bottom-info f fc fbt">
            <div class="f fc">
              <img :src="avatar" class="avatar" crossorigin="anonymous" />

              <div class="user-info">
                <div class="nickname">{{nickname}}邀请你</div>
                <div class="tip">参加活动</div>
              </div>
            </div>
            <img :src="qrcode" class="code-img" crossorigin="anonymous" />
          </div>
        </div>
      </div>
      <div class="rule-area">
        <div class="title" v-if="rule">奖励规则</div>
        <div class="html-content" v-if="rule" v-html="rule"></div>
      </div>
      <div class="f fvc btn-box">
        <div class="back-btn" @click="backHome">返回首页</div>
      </div>
    </div>
    <div style="display: none;">
      <div id="qrcode-simple"></div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import utils from "../../utils/utils";
export default {
  data() {
    return {
      poster: "",
      headImg: "",
      rule: "",
      nickname: "",
      avatar: "",
      scene: "",
      qrcode: "",
      img: "",
      posterFlag: true, // 控制html元素
      canvasFlag: false, //控制canvas元素
    };
  },
  created() {
    this.$initWXSDK(
      {
        openShare: true,
      },
      () => {
        this.$utils.getLocation().then((res) => {});
      }
    );
    this.$store.commit("setLoading", true);
  },
  mounted() {
    this.$nextTick(() => {
      this.getSpokesInfo();
    });
  },
  methods: {
    getSpokesInfo() {
      this.$http.post("/v1/home/spokesman").then((res) => {
        if (res.code === 0) {
          this.poster =
            res.data.promotionImage ||
            "https://j.weizan.cn/youxiang/default-poster-bg.png";
          this.rule = res.data.rule;
          this.avatar = res.data.avatar;
          this.nickname = res.data.nickname;
          this.scene = res.data.scene;
          this.headImg = res.data.headImage;
          let tmp = document.getElementById("posterDOM");
          tmp.onload = () => {
            let base64 = this.getBase64Image(tmp);
            this.poster = base64;
          };
          this.getQRCode().then(() => {
            window.pageYOffset = 0;
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
            setTimeout(() => {
              this.createCanvas();
            }, 200);
          });
        }
      });
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = 800;
      canvas.height = 1420;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, 800, 1420);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      // console.log(dataURL);
      return dataURL;
    },
    async getQRCode() {

      // 第一个参数 场景，第二个actId（活动id）第三个 kpiuserId(kpi)第四个分享用户id
      // TODO: 真实的秒杀分享连接
      // http://localhost:8080/seckillDetailb?id=430&act_id=308&kpi_user_id=427&share_user_id=196&inviteId=undefined&shop_id=0&brand_id=387
      const kpi_user_id = localStorage.getItem("kpi_user_id");
      const user_id = localStorage.getItem("user_id");
      const act_id = this.$route.query.act_id || localStorage.getItem("act_id")
      const codeUrl = `${location.origin}/wx/v1/qrcode/url/2,${act_id},${kpi_user_id},${user_id}`
      $('#qrcode-simple').empty().qrcode({
        text: codeUrl,
        height: 350,
        width: 350
      })
      await utils.sleep(800)
      var newcodeurl = ''
      try {
        newcodeurl = $('#qrcode-simple').find('canvas').get(0).toDataURL('png', 0.6)
      } catch (error) {
        newcodeurl = ''
      }
      if (newcodeurl != '') {
        this.qrcode = newcodeurl
        return
      } else {
        return new Promise((resolve) => {
          this.$http
            .get("/v1/qrcode/gen_code", {
              scene: this.scene,
            })
            .then((res) => {
              this.qrcode = res.data.qrcodeBase64;
              this.$nextTick(() => {
                resolve();
              });
            });
        });
      }
    },
    createCanvas() {
      const that = this;
      html2canvas(this.$refs.poster, {
        useCORS: true, // 允许图片跨域
        // width: 320, // 绘制图片的宽 2倍
        // dpi: window.devicePixelRatio * 2, // dpi  如果模糊的话 就把dpi和scale缩放的值调大 dpi越高生成的图片越大
        // height: 568, // 绘制图片的高 2倍
        scale: 4,
      })
        .then(function (canvas) {
          that.img = canvas.toDataURL("image/jpg");
          setTimeout(() => {
            that.posterFlag = false;
            that.canvasFlag = true;
            that.$store.commit("setLoading", false);
          }, 200);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  background: linear-gradient(
    135deg,
    rgba(90, 201, 255, 1),
    rgba(91, 117, 255, 1)
  );
  min-height: 100vh;
  .head-img {
    width: 100%;
    height: 146px;
  }
  .page-body {
    overflow: hidden;
    position: relative;
  }
  .poster-bg-img {
    width: 100%;
    position: absolute;
    top: -72px;
  }
  .title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #fff;
    text-align: center;
  }
  .html-content {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
    margin-top: 20px;
    line-height: 24px;
    width: 100%;
    text-align: center;
  }
  .btn-box {
    z-index: 100;
    margin: 20px 0;
  }
  .back-btn {
    background: #fff;
    width: 315px;
    height: 44px;
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
  }
}
.rule-area {
  margin-top: 20px;
}
.box {
  width: 251px;
  height: 446px;

  position: relative;
  #capture {
    width: 250px;

    height: 446px;

    margin: 0 0 25px;
    position: fixed;
    left: 0;
    top: -99999px;

    .poster-img {
      width: 252px;

      height: 448px;
    }
    .bottom-info {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: auto;
      background: rgba(255, 255, 255, 0.3);
      // padding: 0 5px;
      &>.f {
        flex-direction: column;
        text-align: center;
        align-items: center;
        justify-content: center;
        flex: 1;
      }
    }
    .code-img {
      width: 120px;
      height: 120px;
    }
    .user-info {
      text-align: center;
      .nickname {
        font-weight: normal;
        margin-bottom: 5px;
        text-align: center;
      }
      .tip {
        font-size: 12px;
        text-align: center;
      }
    }
    .avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-bottom: 5px;
    }
  }
  #canvas-pic {
    width: 251px;
    // height: 284px;
    margin: 0 0 25px;
    z-index: 22;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>